import {
  ActivityFilter,
  getActivity,
  listActivities,
} from '../services/activityServices';

export const activityQueries = {
  all: ['activities'] as const,

  get: (id: number) => ({
    queryKey: [...activityQueries.all, 'get', id] as const,
    queryFn: () => getActivity(id),
  }),

  list: (filters: ActivityFilter = {}) => ({
    queryKey: [...activityQueries.all, 'list', { filters }] as const,
    queryFn: () => listActivities(filters),
  }),

  listInfinite: (filters: ActivityFilter = {}) => ({
    queryKey: [...activityQueries.list(filters).queryKey, 'infinite'] as const,
    queryFn: (ctx: { pageParam?: number }) =>
      listActivities({ ...filters, pageNumber: ctx.pageParam }),
  }),
};
